const debug = require('debug')('utils');

function getLastHour() {
  const config = this?.$nuxt?.$config;
  if (!config) {
    console.error('nuxt config must be provided to getLastHour function');
  }

  // На бразилии оффсет времени +6 часов
  // На мексике +3
  const isBr = config?.COUNTRY === 'br';
  const offset = isBr ? 3 : 6;
  return 23 + offset;
}

const getLastDayOfMonth = function () {
  const config = this?.$nuxt?.$config;
  if (!config) {
    console.error('nuxt config must be provided to getLastDayOfMonth function');
  }
  const lastHour = getLastHour.bind(this)();

  const now = new Date();
  const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  const lastDay = new Date(nextMonth.getTime() - 1);

  // Устанавливаем время в UTC
  lastDay.setUTCHours(lastHour, 59, 59, 999);

  // Проверяем, если дата после установки UTC времени перешла на следующий месяц
  if (lastDay.getUTCMonth() !== now.getMonth()) {
    lastDay.setUTCDate(1);
    lastDay.setUTCMonth(now.getMonth() + 1);
  }

  return lastDay;
};

function nextDate(dayIndex) {
  debug('nextDateBinded dayIndex = %d', dayIndex);

  // Конфиг должен быть доступен, потому что он используется в функции getLastHour
  const config = this?.$nuxt?.$config;
  if (!config) {
    console.error('nuxt config must be provided to nextDate function');
  }
  const lastHour = getLastHour.bind(this)();

  let today = new Date();
  today.setUTCDate(
    today.getDate() + ((dayIndex - 1 - today.getDay() + 7) % 7) + 1,
  );
  return new Date(today.setUTCHours(lastHour, 59, 59, 999));
}

export function getEternalEndDate(unlimitedTimerMode = 'TuFr_SaMo') {
  debug('getEternalEndDate');

  // Конфиг должен быть доступен, потому что он используется в функции getLastHour
  const config = this?.$nuxt?.$config;
  if (!config) {
    console.error('nuxt config must be provided to getEternalEndDate function');
  }

  const lastHour = getLastHour.bind(this)();
  const nextDateBinded = nextDate.bind(this);
  const lastDayOfMonth = getLastDayOfMonth.bind(this)();

  try {
    let day = new Date().getDay();
    let nextSaleEndDate = null;

    // Старый вариант, который использовался до введения режимов бесконечного таймера
    // Со вторника по пятницу, с субботы до вечера понедельника, далее по кругу
    if (unlimitedTimerMode === 'TuFr_SaMo') {
      switch (day) {
        case 0:
          nextSaleEndDate = nextDateBinded(1);
          break; // SUN - Воскресенье
        case 1:
          nextSaleEndDate = new Date(
            new Date().setUTCHours(lastHour, 59, 59, 999),
          );
          break; // MON - Понедельник
        case 2:
          nextSaleEndDate = nextDateBinded(5);
          break; // TUE - Вторник
        case 3:
          nextSaleEndDate = nextDateBinded(5);
          break; // WED - Среда
        case 4:
          nextSaleEndDate = nextDateBinded(5);
          break; // THU - Четверг
        case 5:
          nextSaleEndDate = new Date(
            new Date().setUTCHours(lastHour, 59, 59, 999),
          );
          break; // FRI - Пятница
        case 6:
          nextSaleEndDate = nextDateBinded(1);
          break; // SAT - Суббота
      }
    }

    // Не используется на данный момент
    // С понедельника по вечер пятницы, с субботы до вечера воскресенья, далее по кругу
    if (unlimitedTimerMode === 'MoFr_SaSu') {
      switch (day) {
        case 0:
          nextSaleEndDate = new Date(
            new Date().setUTCHours(lastHour, 59, 59, 999),
          );
          break; // SUN - Воскресенье
        case 1:
          nextSaleEndDate = nextDateBinded(5);
          break; // MON - Понедельник
        case 2:
          nextSaleEndDate = nextDateBinded(5);
          break; // TUE - Вторник
        case 3:
          nextSaleEndDate = nextDateBinded(5);
          break; // WED - Среда
        case 4:
          nextSaleEndDate = nextDateBinded(5);
          break; // THU - Четверг
        case 5:
          nextSaleEndDate = new Date(
            new Date().setUTCHours(lastHour, 59, 59, 999),
          );
          break; // FRI - Пятница
        case 6:
          nextSaleEndDate = nextDateBinded(1);
          break; // SAT - Суббота
      }
    }

    // С понедельника по вечер среды, с четверга по вечер пятницы, с субботы по вечер воскресенья, далее по кругу
    if (unlimitedTimerMode === 'MoWe_ThFr_SaSu') {
      switch (day) {
        case 0:
          nextSaleEndDate = new Date(
            new Date().setUTCHours(lastHour, 59, 59, 999),
          );
          break; // SUN - Воскресенье
        case 1:
          nextSaleEndDate = nextDateBinded(3);
          break; // MON - Понедельник
        case 2:
          nextSaleEndDate = nextDateBinded(3);
          break; // TUE - Вторник
        case 3:
          nextSaleEndDate = new Date(
            new Date().setUTCHours(lastHour, 59, 59, 999),
          );
          break; // WED - Среда
        case 4:
          nextSaleEndDate = nextDateBinded(5);
          break; // THU - Четверг
        case 5:
          nextSaleEndDate = new Date(
            new Date().setUTCHours(lastHour, 59, 59, 999),
          );
          break; // FRI - Пятница
        case 6:
          nextSaleEndDate = nextDateBinded(0);
          break; // SAT - Суббота
      }
    }

    if (nextSaleEndDate && nextSaleEndDate > lastDayOfMonth) {
      nextSaleEndDate = lastDayOfMonth;
    }

    return nextSaleEndDate;
  } catch (e) {
    console.error(e);
  }
}

export const getEternalEndDateV2 = () => {
  debug('getEternalEndDateV2');

  try {
    let day = new Date().getDay();
    let nextSaleEndDate = null;
    switch (day) {
      case 0:
        nextSaleEndDate = new Date(new Date().setHours(23, 59, 59, 999));
        break; // SUN
      case 1:
        nextSaleEndDate = nextDate(5);
        break; // MON
      case 2:
        nextSaleEndDate = nextDate(5);
        break; // TUE
      case 3:
        nextSaleEndDate = nextDate(5);
        break; // WED
      case 4:
        nextSaleEndDate = nextDate(5);
        break; // THU
      case 5:
        nextSaleEndDate = new Date(new Date().setHours(23, 59, 59, 999));
        break; // FRI
      case 6:
        nextSaleEndDate = nextDate(7);
        break; // SAT
    }

    return nextSaleEndDate;
  } catch (e) {
    console.error(e);
  }
};
